import { useState, type FormEvent, type ReactElement } from 'react';
import { useSession } from '../coquille/ContexteSession.js';
import { EchecApi } from '../api.js';

/**
 * L'ECRAN DE CONNEXION.
 *
 * ── LE MESSAGE DE REFUS VIENT DE L'API, TOUJOURS ────────────────────────
 *
 * Elle rend UN SEUL message pour six situations -- compte inconnu, sans mot de
 * passe, suspendu, archive, mot de passe faux, derive corrompu -- precisement
 * pour ne donner aucun ORACLE D'ENUMERATION. Fabriquer ici un message plus
 * precis defairait cette protection, et le cout d'Argon2 paye pour l'egaliser
 * aurait ete depense pour rien.
 *
 * ── LA LIMITATION SE DIT AUTREMENT ──────────────────────────────────────
 *
 * `trop_de_tentatives` (429) n'est pas un refus d'identifiants : c'est une
 * attente. On le distingue pour ne pas laisser quelqu'un ressaisir dix fois un
 * mot de passe correct en croyant se tromper.
 */
export function Connexion(): ReactElement {
  const { connecter } = useSession();
  const [email, setEmail] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [refus, setRefus] = useState<{ message: string; attente: boolean } | undefined>();
  const [enCours, setEnCours] = useState(false);

  async function soumettre(e: FormEvent): Promise<void> {
    e.preventDefault();
    setEnCours(true);
    setRefus(undefined);
    try {
      await connecter(email, motDePasse);
    } catch (x) {
      const api = x instanceof EchecApi ? x.detail : undefined;
      setRefus({
        message: api?.message ?? 'La connexion a échoué.',
        attente: api?.code === 'trop_de_tentatives',
      });
      setEnCours(false);
    }
  }

  return (
    <div className="plein-centre">
      <div>
        <h1>Anelya</h1>
        <p className="discret">Automatisation</p>
      </div>
      <form className="carte" onSubmit={(e) => { void soumettre(e); }}>
        <div className="champ">
          <label htmlFor="email">Adresse électronique</label>
          <input id="email" type="email" autoComplete="username" required
                 autoFocus disabled={enCours}
                 value={email} onChange={(e) => { setEmail(e.target.value); }} />
        </div>
        <div className="champ" style={{ marginTop: 'var(--espace-4)' }}>
          <label htmlFor="mdp">Mot de passe</label>
          <input id="mdp" type="password" autoComplete="current-password" required
                 disabled={enCours}
                 value={motDePasse} onChange={(e) => { setMotDePasse(e.target.value); }} />
        </div>
        {refus !== undefined && (
          <p className={refus.attente ? 'message message--alerte' : 'message message--refus'}
             role="alert" style={{ marginTop: 'var(--espace-4)' }}>
            {refus.message}
          </p>
        )}
        <button type="submit" className="bouton bouton--principal" disabled={enCours}
                style={{ marginTop: 'var(--espace-6)', width: '100%' }}>
          {enCours ? 'Connexion…' : 'Se connecter'}
        </button>
      </form>
    </div>
  );
}
